import convertToResults from './convertToResults';

const filter = function filterByTitle(term, arr) {
  return arr.filter(item =>
    item.title.toUpperCase().includes(term.toUpperCase())
  );
};

const generateResults = function generateResultsObjects(
  searchTerm,
  genres,
  stations,
  terms,
  match,
  showModal
) {
  const filteredGenres = filter(
    searchTerm,
    convertToResults(genres, match, 'genre', showModal)
  );
  const filteredStations = filter(
    searchTerm,
    convertToResults(stations, match, 'station', showModal)
  );
  return {
    genres: {
      name: terms[0],
      results: filteredGenres
    },
    stations: {
      name: terms[1],
      results: filteredStations
    }
  };
};

export default generateResults;
